var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header-sidenav-menu"}},[_vm._t("default"),_c("sidenav_menu_01",{tag:"component",attrs:{"config":_vm.styleMenu,"data":_vm.siteComponents,"is_public":_vm.isPreview}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }